import { render, staticRenderFns } from "./CustomizedSettings.vue?vue&type=template&id=4ac0797c&scoped=true"
import script from "./CustomizedSettings.vue?vue&type=script&lang=js"
export * from "./CustomizedSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac0797c",
  null
  
)

export default component.exports